/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type StoreManagementCreateItemRequest = {
    categoryId: number;
    subCategoryId?: number;
    code: string;
    type: StoreManagementCreateItemRequest.type;
    language: StoreManagementCreateItemRequest.language;
    name: string;
    nameEn?: string;
    nameCn?: string;
    optioNames?: string;
    optioNamesEn?: string;
    optioNamesCn?: string;
    company?: string;
    companyEn?: string;
    companyCn?: string;
    isPrice: boolean;
    price?: number;
    salePrice?: number;
    isQuantity: boolean;
    quantity?: number;
    context?: string;
    contextEn?: string;
    contextCn?: string;
    openStatus: StoreManagementCreateItemRequest.openStatus;
    releaseSetting?: StoreManagementCreateItemRequest.releaseSetting;
    postDate?: string;
    saleId?: number;
    saleCode?: string;
    startDate?: string;
    endDate?: string;
};

export namespace StoreManagementCreateItemRequest {

    export enum type {
        CONSUMER = 'consumer',
        BUSINESS = 'business',
        BOTH = 'both',
    }

    export enum language {
        JAPANESE = 'japanese',
        FOREIGN = 'foreign',
        ALL = 'all',
        NOT = 'not',
    }

    export enum openStatus {
        HOLD = 'hold',
        RELEASE = 'release',
        NO_RELEASE = 'no_release',
    }

    export enum releaseSetting {
        NOW = 'now',
        DATE = 'date',
    }


}

